import { render, staticRenderFns } from "./VehicleProvisionDispatcher.vue?vue&type=template&id=3c01bd3e&scoped=true&"
import script from "./VehicleProvisionDispatcher.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionDispatcher.vue?vue&type=style&index=0&id=3c01bd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01bd3e",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QBtn,QTooltip,QIcon,QCardActions,QSeparator,QCard,QCardSection,QExpansionItem,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QBtn,QTooltip,QIcon,QCardActions,QSeparator,QCard,QCardSection,QExpansionItem,QInnerLoading,QSpinnerGears}, component.options.components || {})
